// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.jM1wy{--typography-color: var(--wpp-icon-color-disabled)}`, "",{"version":3,"sources":["webpack://./src/components/FormComponents/NoneAddedRender/NoneAddedRender.module.scss"],"names":[],"mappings":"AACA,OACE,kDAAA","sourcesContent":["@import \"/home/runner/work/commerce-studio/commerce-studio/apps/commerce-studio/src/styles/shared/utils.scss\";\n.noneAdded {\n  --typography-color: var(--wpp-icon-color-disabled);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"noneAdded": `jM1wy`
};
export default ___CSS_LOADER_EXPORT___;
